import React from "react";
import { IoArrowBack } from "react-icons/io5";
import { NavigateBackBtnDTO } from "../../typings/uicomponents";

const NavigatebackBtn: React.FC<NavigateBackBtnDTO> = ({ onclick , style}) => (
  <IoArrowBack
    onClick={() => {
      onclick();
    }}
    size={40}
    className={`p-2 bg-white rounded-lg ${style} shadow text-primary`}
  />
);

export default NavigatebackBtn;
